import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import F2 from './components/F2';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import J from './components/J';
import K from './components/K';
import L from './components/L';
import M from './components/M';
import N from './components/N';
import Tab from './components/Tab';
import Float from './components/Float';
import { useGlobal } from '@/utils/useGlobal';
import O from './components/O';

export default function IndexDynamic() {
    const { useState, useEffect, useRouter } = useGlobal();
    const router = useRouter();
    const { locale, query } = router;
    const [initDone, setInitDone] = useState(false);
    const EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'];
    const nowTime = query?.timer ? new Date(`${query?.timer} GMT+8`).getTime() : new Date().getTime();
    const LaunchTime_AU = new Date('2024/06/10 10:00:00 GMT+8').getTime();
    const AU_ENTER_LAUNCH_FLAG = nowTime >= LaunchTime_AU;

    useEffect(() => {
        if (locale === 'au' && nowTime < new Date('2024/06/03 10:00:00 GMT+8').getTime()) {
            router.push('/404');
        }
    }, []);

    useEffect(() => {
        if (initDone && document.referrer && window.location?.hash) {
            setTimeout(() => {
                window.location.href = window.location?.hash;
            }, 50);
        }
    }, [initDone]);

    return (
        <>
            <Tab />
            <div className="black-wrapper">
                <Float />
                <B />
                <C />
                {['us', 'ca'].includes(locale) ? <O /> : <D />}
                <E />
                {locale === 'au' && !AU_ENTER_LAUNCH_FLAG && <M />}
                <F callback={() => setInitDone(true)} />
                {['us', 'ca'].includes(locale) && <F2 />}
                {EU_SITES.includes(locale) && <N />}
            </div>
            {EU_SITES.includes(locale) && <G />}
            <H />
            <I />
            <J />
            {!['eu', 'kr', 'nl'].includes(locale) && <K />}
            {!['kr', 'za'].includes(locale) && <L />}
        </>
    );
}
